import { TrainingGroupSearchInput } from "../../types/training-group/TGSearchInput";
import { TrainingGroup } from "../../types/training-group/TrainingGroup";
import { SportAssociationNumberOf } from "../../types/SportAssociation";

type MultiTGResponse = {
  trainingGroups: TrainingGroup[];
  nextPage: number;
};

export const fetchTrainingGroups = async (
  backendUrl: string,
  sportAssociation: string,
  body: TrainingGroupSearchInput,
): Promise<MultiTGResponse> => {
  const response = await fetch(backendUrl + "/training-group/", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      "X-Sport-Association": SportAssociationNumberOf(sportAssociation),
    },
    body: JSON.stringify(body),
  });
  const data = await response.json();
  return data;
};
